import React, { Component } from 'react'
import { connect } from 'react-redux'
import { connectForm, Form, Field, Submit } from '~/form'
import { Map, List, fromJS } from 'immutable'
import { dataTableItemCreate } from '../actions'

class DataTableCreate extends Component {
  static formSubmit(dispatch, formId, values, changed, meta) {
    dispatch(dataTableItemCreate(meta.table_id, meta.entity, values, formId))
  }

  static formValidation = (values, changed, meta) => {
    let { fields = [] } = meta

    return fields.reduce((validations, { name, validation = [], override = {}, create = true }) => {
      if (!create) return validations

      if (override.create && override.create.validation) validation = override.create.validation

      validations[name] = validation
      return validations
    }, {})
  }

  componentWillMount() {
    let { formSetMeta, table_id, entity, config } = this.props
    formSetMeta({ table_id, entity, fields: config.get('formFields', List()).toJS() })
  }

  componentWillUnmount() {
    let { formReset } = this.props
    formReset()
  }

  componentDidMount() {
    if (!this._parent) return

    let input = this._parent.querySelector('input')
    input ? input.focus() : null
  }

  render() {
    let { config, configLoading, formUpdate, formSubmit, formState, formLoading, onCancel } = this.props

    let fields = config.get('formFields', List())

    return (
      <div className="datatable-action datatable-action--create" ref={el => (this._parent = el)}>
        <Form onSubmit={formSubmit} formState={formState}>
          <div className="datatable-action-content">
            {fields
              .toJS()
              .map(
                ({
                  label,
                  inputLabel,
                  type,
                  name,
                  options = [],
                  referenceConfig = {},
                  multiple = false,
                  create = true,
                  ...inputProps
                }) => {
                  if (!create) return null

                  return (
                    <Field
                      {...inputProps}
                      label={label}
                      inputLabel={inputLabel}
                      type={type}
                      name={name}
                      options={options}
                      referenceConfig={referenceConfig}
                      multiple={multiple}
                      key={name}
                      onChange={formUpdate}
                      formState={formState}
                    />
                  )
                }
              )}
          </div>
          <div className="datatable-action-buttons">
            <Submit content="Tallenna" icon="save" color="green" />
            <button className="datatable-action-button-cancel" onClick={e => e.preventDefault() & onCancel()}>
              Sulje
            </button>
          </div>
        </Form>
      </div>
    )
  }
}

export default connectForm('datatable-create', DataTableCreate)
